// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

// Optional theming:
import { ThemeProvider, createTheme, defaultTheme } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import './App.css'; // your global styles

import App from './App';

Amplify.configure(awsExports);

/**
 * Optional: single light theme.
 * If you prefer no theming at all, remove ThemeProvider below.
 */
const myTheme = createTheme({
    name: 'my-theme',
    overrides: [defaultTheme],
});

function Root() {
    return (
        <ThemeProvider theme={myTheme}>
            <App />
        </ThemeProvider>
    );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root />);
